export const appVersion = 'v2.0.48';